import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Percentile from '../percentile/index.vue';

@Options<AllocationPercentile>({
  components: {
    Percentile
  }
})
export default class AllocationPercentile extends Vue {

  @Prop()
  private question!: any;

  private validSubQuestion: boolean[] = [];
  // private subQuestions: any[] = [];


  created(): void {
    this.validSubQuestion = this.question.atcsSubQuestions.map((q: any) => false);
    // this.subQuestions = this.question.atcsSubQuestions.map((q: any) => q);
    this.question.atcsSubQuestions.forEach((q: any, i: any) => {
      q.responses.forEach((r: any) => {
        this.question.atcsSubQuestions[i].responses[0].answerNumber = r.value ?? 0;
      });
    });
    this.$emit('validForm', this.validForm());
  }

  private onValueChanged(event: any, i: any): void {
    this.$emit('changed', event);
    // this.$emit('validForm', this.validForm());
  }

  private validForm(): boolean {
    // const allFieldsValid = !this.validSubQuestion.includes(false);
    const chk1 = this.totalPercentage == 100;
    return chk1;
  }

  private validationForm(i: any, isValid: any) {
    this.validSubQuestion[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get totalPercentage(): number {
    let total = 0;
    this.question.atcsSubQuestions.forEach((q: any, i: any) => {
      if (q.responses[0].answerNumber != null && Number.isInteger(q.responses[0].answerNumber)) {
        total += q.responses[0].answerNumber;
      }
    });
    return total;
  }
}
